import { defineComponent as Oe, useAttrs as Ie, useSlots as Me, ref as c, computed as h, watch as U, nextTick as Y, onMounted as Fe, onUnmounted as Re, createBlock as J, openBlock as r, mergeProps as $e, unref as y, createSlots as Pe, withCtx as S, createElementVNode as f, toDisplayString as g, withDirectives as M, createElementBlock as d, Fragment as V, renderList as K, withKeys as re, normalizeClass as F, createCommentVNode as R, renderSlot as G, createTextVNode as $, withModifiers as P, createVNode as b, Teleport as ze, Transition as He, normalizeStyle as Ne, vModelText as Ae, vShow as Q } from "vue";
import { u as De, a as Le, f as Ue, o as Ve, s as Ke } from "./floating-ui.vue-pzUuloyX.js";
import Ge from "@leaflink/snitch";
import qe from "lodash-es/debounce";
import je from "lodash-es/isEmpty";
import ie from "lodash-es/isEqual";
import We from "lodash-es/isPlainObject";
import Xe from "lodash-es/uniqueId";
import Ye from "./useSearch.js";
import { DEBOUNCE as Je, KEY_CODES as E } from "./constants.js";
import Qe from "./directives/clickoutside.js";
import { D as Ze } from "./MenusPlugin-Bk6UW6o9.js";
import ce from "./Chip.js";
import z from "./Icon.js";
import { _ as et } from "./Field.vue_vue_type_script_setup_true_lang-DI6z3AE9.js";
import { _ as tt } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const lt = { class: "tw-flex tw-h-input tw-items-center tw-text-sm" }, st = ["id", "aria-labelledby"], at = ["id", "aria-errormessage", "aria-invalid", "disabled", "multiple", "name"], nt = ["selected", "value", "disabled"], ot = ["aria-controls", "aria-expanded", "aria-label", "aria-disabled"], rt = ["id"], it = ["onKeypress", "onMousedown"], ct = {
  key: 0,
  class: "stash-select__total"
}, ut = {
  key: 0,
  class: "tw-flex tw-items-center tw-border-b tw-border-blue-500 tw-pr-1.5"
}, dt = ["data-test", "placeholder"], ft = { class: "stash-select__options options tw-my-1.5 tw-w-full tw-border-white tw-bg-white" }, pt = ["data-test", "onClick", "onMouseenter"], ht = {
  key: 0,
  class: "tw-ml-auto tw-pl-1.5"
}, vt = { class: "tw-m-1.5 tw-cursor-default tw-p-1.5" }, mt = {
  class: "tw-m-1.5 tw-cursor-default tw-p-1.5",
  "data-test": "stash-select|no-options"
}, yt = /* @__PURE__ */ Oe({
  name: "ll-select",
  __name: "Select",
  props: {
    preventEmpty: { type: Boolean, default: !1 },
    allowEmpty: { type: [String, Boolean, null], default: null },
    displayBy: { default: "name" },
    searchBy: { default: () => [] },
    trackBy: { default: "id" },
    placeholder: { default: "Select option" },
    error: { default: "" },
    hint: { default: "" },
    icon: { type: [String, Boolean], default: "caret-down" },
    name: { default: void 0 },
    options: { default: () => [] },
    lazy: { type: Function, default: void 0 },
    modelValue: { default: () => [] },
    value: { default: null },
    hideSearch: { type: Boolean, default: !1 },
    searchable: { type: [String, Boolean, null], default: null },
    preserveSearchTerm: { type: Boolean, default: !1 },
    disableFiltering: { type: Boolean, default: !1 },
    single: { type: Boolean, default: !1 },
    noTruncate: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    searchLoading: { type: Boolean, default: !1 },
    selectItemType: { default: "" },
    hideCheck: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Search" },
    onSearch: { type: Function, default: void 0 },
    useFuzzySearch: { type: Boolean, default: !1 },
    menuPlacement: { default: "bottom-start" },
    enableTeleport: { type: Boolean, default: !1 },
    teleportTo: { default: `#${Ze}` },
    addBottomSpace: { type: Boolean },
    errorText: {},
    hintText: {},
    id: {},
    errorId: {},
    isReadOnly: { type: Boolean },
    isRequired: { type: Boolean },
    label: {},
    showOptionalInLabel: { type: Boolean },
    isLabelSrOnly: { type: Boolean },
    fieldset: { type: Boolean },
    isDisabled: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:model-value", "clear", "add", "remove", "opened", "closed"],
  setup(ue, { emit: de }) {
    const t = ue, v = de, H = Ie(), fe = Me(), Z = c(null), m = c(null), x = c(null), q = c(null), ee = c(null), N = c(0), T = c(0), n = c([]), te = c(() => []), w = c(""), p = c(-1), u = c(!1), j = c({}), le = c(!1), { floatingStyles: pe } = De(Z, x, {
      whileElementsMounted: Le,
      placement: t.menuPlacement,
      middleware: [
        Ue(),
        Ve(({ rects: e, placement: l }) => l.split("-")[0] === "bottom" && N.value > T.value ? N.value - e.reference.height + 6 : 6),
        Ke({
          apply({ availableHeight: e, elements: l, rects: a }) {
            t.enableTeleport && Object.assign(l.floating.style, {
              maxWidth: `${a.reference.width}px`,
              maxHeight: `${Math.min(e, 300)}px`
            });
          }
        })
      ]
    }), W = h(() => !t.hideSearch && t.searchable !== "false" && t.searchable !== !1), A = h(() => {
      let e = (le.value && t.lazy ? t.lazy() : t.options).filter(Boolean);
      return We(e[0]) || (e = e.map((l, a) => ({ name: l, id: a }))), e;
    }), he = h(() => n.value.length ? n.value.map((e) => e[t.displayBy] || e).join(", ") : ""), se = h(() => t.searchLoading || Object.keys(j.value).length > 0), C = h(() => t.disableFiltering || !(w.value || "").trim() ? A.value : te.value(w.value)), ve = h(() => N.value <= T.value), me = h(
      () => !u.value && !t.single && !ve.value && n.value.length
    ), ye = h(() => [n.value.length, t.selectItemType, "selected"].filter(Boolean).join(" ")), we = h(() => t.preventEmpty || t.allowEmpty === "false" || t.allowEmpty === !1);
    U(w, (e, l) => l !== e && L(-1)), U(n, () => I(), { deep: !0 }), U(
      () => t.modelValue,
      (e) => {
        if (Array.isArray(e)) {
          const l = e.filter(Boolean);
          ie(l, n.value) || (n.value = l);
          return;
        }
        if (!je(e)) {
          ie(e, n.value[0]) || (n.value[0] = e);
          return;
        }
        n.value = [];
      },
      { immediate: !0 }
    ), U(
      () => t.options,
      () => {
        const { searchFor: e } = Ye({
          items: h(() => A.value),
          fieldNames: t.searchBy.length ? t.searchBy : [t.displayBy],
          trackBy: t.trackBy
        });
        te.value = (l) => e(l, { fuzzy: t.useFuzzySearch });
      },
      { immediate: !0 }
    );
    const X = (e) => e && typeof e == "object" && "disabled" in e && (e == null ? void 0 : e.disabled), _e = () => {
      n.value = [], v("update:model-value", t.single ? void 0 : n.value), v("clear");
    }, D = (e) => {
      t.disabled || !e || X(e) || (k(e) ? O(e) : (t.single && (n.value = []), n.value.push(e), v("update:model-value", t.single ? n.value[0] : n.value), v("add", e)), t.single && B());
    }, ge = (e) => {
      if (t.single) {
        const a = A.value.find((o) => {
          var i;
          return ((i = o[t.trackBy]) == null ? void 0 : i.toString()) === e.target.value;
        });
        D(a);
        return;
      }
      const l = [...e.target.selectedOptions];
      for (const a of [...n.value])
        l.find((i) => {
          var s;
          return i.value === ((s = a[t.trackBy]) == null ? void 0 : s.toString());
        }) || O(a);
      for (const a of l) {
        const o = A.value.find(
          (i) => {
            var s;
            return ((s = i[t.trackBy]) == null ? void 0 : s.toString()) === a.value;
          }
        );
        k(o) || D(o);
      }
    }, O = (e) => {
      if (t.disabled || we.value && n.value.length === 1)
        return;
      const l = n.value.findIndex((a) => a[t.trackBy] === e[t.trackBy]);
      if (l === -1) {
        Ge.warn("ll-select: could not find option to remove", e);
        return;
      }
      n.value.splice(l, 1), v("update:model-value", t.single ? n.value[0] : n.value), v("remove", e, l);
    }, ae = () => {
      u.value || (I(), u.value = !0, v("opened"), W.value && Y(() => {
        var e;
        (e = ee.value) == null || e.focus({ preventScroll: !0 });
      }));
    }, B = () => {
      var e;
      u.value && v("closed", n.value), L(-1), u.value = !1, t.preserveSearchTerm || (w.value = ""), (e = m.value) == null || e.blur();
    }, be = async (e) => {
      if (await Y(), !m.value)
        return;
      if (![E.ENTER, E.ESCAPE].includes(e.keyCode)) {
        const a = m.value.querySelector(".stash-select__option--highlighted"), o = a == null ? void 0 : a.getBoundingClientRect(), i = m.value.getBoundingClientRect();
        if (!o || !i)
          return;
        (o.bottom >= i.bottom || o.top <= i.top + o.height) && (a == null || a.scrollIntoView({ block: "nearest", inline: "nearest" }));
      }
    }, L = (e) => {
      p.value = e;
    }, Be = (e) => {
      if (e.keyCode === E.ESCAPE)
        B();
      else if (e.keyCode === E.DOWN && p.value < C.value.length - 1 && u.value)
        p.value++;
      else if (e.keyCode === E.UP && p.value > 0)
        u.value && p.value--, x.value && W.value && p.value === 0 && (x.value.scrollTop -= 100);
      else if (e.keyCode === E.ENTER && p.value !== -1 && u.value)
        D(C.value[p.value]);
      else
        return;
      e.preventDefault(), be(e);
    }, ne = qe(function() {
      ke();
    }, Je.FAST), ke = async function() {
      if (!t.onSearch)
        return;
      const e = Xe("search-request-");
      try {
        j.value[e] = !0, await t.onSearch(w.value);
      } finally {
        delete j.value[e];
      }
    }, Se = (e, l) => [
      {
        "stash-select__option": !0,
        "stash-select__option--disabled": X(e),
        "stash-select__option--highlighted": p.value === l,
        "stash-select__option--selected": k(e)
      },
      // @deprecated
      // backwards compatibility
      {
        "is-selected": p.value === l,
        "tw-bg-ice-200": p.value === l,
        "tw-bg-blue-100 tw-text-ice-700": k(e)
      }
    ], k = (e) => e == null ? !1 : n.value.some((l) => (l == null ? void 0 : l[t.trackBy]) === e[t.trackBy]);
    function oe(e) {
      var o, i;
      if (!e)
        return !1;
      const l = (o = m.value) == null ? void 0 : o.contains(e), a = (i = x.value) == null ? void 0 : i.contains(e);
      return l || a;
    }
    function Ee(e) {
      const l = e.relatedTarget;
      !oe(l) && l && B();
    }
    function xe(e) {
      const l = e.target;
      oe(l) || B();
    }
    const Te = () => {
      L(-1);
    }, I = async () => {
      await Y(), q.value && m.value && (T.value = T.value === 0 ? m.value.clientHeight : T.value, N.value = q.value.clientHeight);
    };
    return Fe(() => {
      if (H.onInput)
        throw new Error("ll-select: use the @update:model-value event instead of @input.");
      window.addEventListener("resize", I), I();
    }), Re(() => {
      window.removeEventListener("resize", I);
    }), (e, l) => (r(), J(et, $e(t, {
      class: ["input ll-select stash-select", y(H).class],
      "data-test": "stash-select",
      "error-text": t.errorText || t.error,
      "hint-text": t.hintText || t.hint
    }), Pe({ _: 2 }, [
      t.isReadOnly ? {
        name: "default",
        fn: S(({ fieldId: a, labelId: o }) => [
          f("div", lt, [
            f("span", {
              id: a,
              "aria-labelledby": o,
              class: "show-empty tw-h-min"
            }, g(he.value), 9, st)
          ])
        ]),
        key: "0"
      } : {
        name: "default",
        fn: S(({ fieldId: a, fieldErrorId: o, hasError: i }) => [
          f("select", {
            id: a,
            "aria-errormessage": o,
            "aria-invalid": i,
            class: "tw-sr-only",
            disabled: t.disabled,
            multiple: !t.single,
            name: t.name,
            onChange: ge
          }, [
            (r(!0), d(V, null, K(C.value, (s, _) => (r(), d("option", {
              key: `srOnlyOption-${_}`,
              selected: k(s),
              value: s[t.trackBy],
              disabled: X(s)
            }, g(s[t.displayBy] || ""), 9, nt))), 128)),
            l[5] || (l[5] = f("option", { value: "" }, null, -1))
          ], 40, at),
          M((r(), d("div", {
            ref_key: "selectRef",
            ref: Z,
            role: "listbox",
            "aria-hidden": "true",
            class: F(["stash-select__content-wrapper", [
              {
                "stash-select--disabled": !!t.disabled,
                "stash-select--error": !!(t.errorText || t.error),
                "stash-select--active": u.value,
                "stash-select--single": t.single
              },
              // @deprecated
              // backwards compatibility
              {
                "is-active": u.value,
                "is-single": t.single,
                "is-disabled": t.disabled
              }
            ]]),
            "aria-controls": "listbox-" + a,
            "aria-expanded": u.value,
            "aria-label": t.placeholder,
            "aria-disabled": t.disabled || void 0,
            onKeydown: Be,
            onKeyup: re(B, ["esc"])
          }, [
            f("div", {
              id: "listbox-" + a,
              ref_key: "contentRef",
              ref: m,
              class: "input-field stash-select__content",
              tabindex: "0",
              "data-test": "stash-select|dropdown-trigger",
              onFocusin: ae,
              onFocusinOnce: l[4] || (l[4] = (s) => le.value = !0),
              onFocusout: Ee,
              onKeydown: ae,
              onMouseleave: Te
            }, [
              f("ul", {
                ref_key: "chipsRef",
                ref: q,
                class: "stash-select__chips"
              }, [
                n.value.length ? R("", !0) : (r(), d("li", {
                  key: 0,
                  class: F(["stash-select__placeholder tw-mr-0 tw-pl-1.5", { "tw-truncate": !t.noTruncate }])
                }, g(t.placeholder), 3)),
                t.single ? (r(!0), d(V, { key: 1 }, K(n.value, (s) => (r(), d("li", {
                  key: `chip-${s[t.trackBy]}`,
                  class: F(["stash-select__selected tw-mr-0 tw-pl-1.5", { "tw-truncate": !t.noTruncate }])
                }, [
                  G(e.$slots, "selected", { option: s }, () => [
                    $(g(s[t.displayBy] || s) + " ", 1),
                    f("button", {
                      tabindex: "-1",
                      class: "stash-select__remove",
                      onKeypress: re(P((_) => O(s), ["prevent"]), ["enter"]),
                      onMousedown: P((_) => O(s), ["prevent", "stop"])
                    }, [
                      b(z, {
                        icon: "close",
                        name: "close",
                        size: "small"
                      })
                    ], 40, it)
                  ], !0)
                ], 2))), 128)) : (r(!0), d(V, { key: 2 }, K(n.value, (s) => (r(), d("li", {
                  key: `chip-${s[t.trackBy]}`,
                  class: "tw-inline-block"
                }, [
                  b(ce, {
                    "bg-color": "blue-500",
                    "is-removable": "",
                    "text-color": "white",
                    class: "stash-select__chip",
                    onRemove: (_) => O(s)
                  }, {
                    default: S(() => [
                      $(g(s[t.displayBy] || s), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]))), 128))
              ], 512),
              me.value ? (r(), d("div", ct, [
                b(ce, {
                  "bg-color": "blue-500",
                  "is-removable": "",
                  "text-color": "white",
                  class: "stash-select__chip",
                  onRemove: _e
                }, {
                  default: S(() => [
                    $(g(ye.value), 1)
                  ]),
                  _: 1
                })
              ])) : R("", !0),
              t.icon ? (r(), J(z, {
                key: 1,
                class: F(["stash-select__icon", { "tw-text-ice-500": t.disabled }]),
                "data-test": "stash-select|toggle-icon",
                name: t.icon,
                onMousedown: l[0] || (l[0] = P((s) => u.value && B(), ["prevent"]))
              }, null, 8, ["name", "class"])) : R("", !0),
              (r(), J(ze, {
                to: t.teleportTo,
                disabled: !t.enableTeleport
              }, [
                b(He, { name: "fade" }, {
                  default: S(() => [
                    M(f("div", {
                      ref_key: "optionsWrapperRef",
                      ref: x,
                      class: "stash-select__border-selector tw-w-full tw-shadow-2xl",
                      style: Ne(y(pe)),
                      onClick: l[3] || (l[3] = P(() => {
                      }, ["stop"]))
                    }, [
                      W.value ? (r(), d("div", ut, [
                        M(f("input", {
                          ref_key: "searchRef",
                          ref: ee,
                          "onUpdate:modelValue": l[1] || (l[1] = (s) => w.value = s),
                          type: "text",
                          autocomplete: "off",
                          class: "stash-select__search",
                          "data-test": y(H)["data-test"] ? y(H)["data-test"] + "-search" : "stash-select|search",
                          placeholder: t.searchPlaceholder,
                          spellcheck: !1,
                          onInput: l[2] || (l[2] = //@ts-ignore
                          (...s) => y(ne) && y(ne)(...s))
                        }, null, 40, dt), [
                          [Ae, w.value]
                        ]),
                        b(z, {
                          name: "search",
                          class: "tw-text-ice-500"
                        })
                      ])) : R("", !0),
                      f("ul", ft, [
                        (r(!0), d(V, null, K(C.value, (s, _) => (r(), d("li", {
                          key: `option-${s[t.trackBy]}`,
                          "data-test": s[t.trackBy],
                          class: F(Se(s, _)),
                          onClick: (Ce) => D(s),
                          onMouseenter: P((Ce) => L(_), ["self"])
                        }, [
                          G(e.$slots, "option", { option: s }, () => [
                            $(g(s[t.displayBy] || s), 1)
                          ], !0),
                          k(s) && !t.hideCheck ? (r(), d("span", ht, [
                            b(z, {
                              class: "tw-text-blue-500",
                              name: "check"
                            })
                          ])) : R("", !0)
                        ], 42, pt))), 128)),
                        M(f("li", vt, [
                          b(z, {
                            "data-test": "stash-select|options-loading",
                            name: "working",
                            class: "tw-animate-spin tw-text-ice-500"
                          })
                        ], 512), [
                          [Q, t.loading || se.value]
                        ]),
                        M(f("li", mt, [
                          G(e.$slots, "no-options", {}, () => [
                            l[6] || (l[6] = $(" No options "))
                          ], !0)
                        ], 512), [
                          [Q, !t.loading && !se.value && !C.value.length]
                        ])
                      ])
                    ], 4), [
                      [Q, u.value && !t.disabled]
                    ])
                  ]),
                  _: 3
                })
              ], 8, ["to", "disabled"]))
            ], 40, rt)
          ], 42, ot)), [
            [y(Qe), xe]
          ])
        ]),
        key: "1"
      },
      y(fe).hint ? {
        name: "hint",
        fn: S(() => [
          G(e.$slots, "hint", {}, void 0, !0)
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["class", "error-text", "hint-text"]));
  }
}), zt = /* @__PURE__ */ tt(yt, [["__scopeId", "data-v-c5883dfe"]]);
export {
  zt as default
};
//# sourceMappingURL=Select.js.map
